var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInfo = function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 20C4.458 20 0 15.522 0 10S4.458 0 10 0s10 4.477 10 10-4.458 10-10 10m0-18c-4.458 0-8.072 3.582-8.072 8S5.542 17.998 10 17.998s7.952-3.58 7.952-8c0-4.417-3.494-8-7.952-8m0 6.75c.723 0 1.205.56 1.205 1.25v4c0 .69-.482 1.25-1.205 1.25S8.675 14.69 8.675 14v-4c0-.69.602-1.25 1.325-1.25M10 5c-.723 0-1.325.56-1.325 1.25S9.277 7.5 10 7.5s1.205-.56 1.205-1.25S10.723 5 10 5"
  })));
};
export default SvgIconInfo;